<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PR9.w.0.0.0.8"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PR6"></a>
<div class="gimg_graphic" id="block.7.0.0.box.158.63.1499.2461.q.101">
<a id="GBS.PR9.w.0.0.0.9"></a><img alt="[graphic]" src="data/content-0005.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PR9.w.0.0.0.10"></a></div>
</div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PR7"></a>
<div class="gimg_graphic" id="block.8.0.0.box.110.72.1470.2464.q.101">
<a id="GBS.PR9.w.0.0.0.11"></a><img alt="[graphic]" src="data/content-0006.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PR9.w.0.0.0.12"></a></div>
</div>
<div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PR9.w.0.0.0.13"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0007.vue?9e6db31c